export function webhooksFromAPI(api) {
    var _a;
    const webhooks = [];
    if ('webhooks' in api) {
        for (const [webhookName, pathItem] of Object.entries((_a = api.webhooks) !== null && _a !== void 0 ? _a : {})) {
            if (typeof pathItem !== 'object' || pathItem === null) {
                continue;
            }
            const { get, put, post, delete: deleteOperation, options, head, patch, trace } = pathItem;
            if (get) {
                webhooks.push([webhookName, pathItem, 'get', get]);
            }
            if (put) {
                webhooks.push([webhookName, pathItem, 'put', put]);
            }
            if (post) {
                webhooks.push([webhookName, pathItem, 'post', post]);
            }
            if (deleteOperation) {
                webhooks.push([webhookName, pathItem, 'delete', deleteOperation]);
            }
            if (options) {
                webhooks.push([webhookName, pathItem, 'options', options]);
            }
            if (head) {
                webhooks.push([webhookName, pathItem, 'head', head]);
            }
            if (patch) {
                webhooks.push([webhookName, pathItem, 'patch', patch]);
            }
            if (trace) {
                webhooks.push([webhookName, pathItem, 'trace', trace]);
            }
        }
    }
    // Sort by resources, then role
    return webhooks.sort(([, , , a], [, , , b]) => {
        var _a, _b;
        let aIndex = a.tags && a.tags.length > 0
            ? ((_a = api.tags) !== null && _a !== void 0 ? _a : []).findIndex((tag) => tag.name === a.tags[0])
            : Number.MAX_VALUE;
        let bIndex = b.tags && b.tags.length > 0
            ? ((_b = api.tags) !== null && _b !== void 0 ? _b : []).findIndex((tag) => tag.name === b.tags[0])
            : Number.MAX_VALUE;
        if (aIndex >= 0 && bIndex >= 0) {
            return aIndex - bIndex;
        }
        else if (aIndex >= 0) {
            return -1;
        }
        else if (bIndex >= 0) {
            return 1;
        }
        else {
            return 0;
        }
    });
}
